<template>
    <b-modal class="modal" ref="modal1" size="xl" title="Question Editor" effect="fade/zoom" @close="close">
        <b-row>
            <b-col cols="1">
            </b-col>
            <b-col cols="10">
                <div>
                    <b-row>
                        <b-col cols="2">Title:</b-col>
                        <b-col cols="4">
                            <b-form-input :id="`question-name${ measure._id }`" v-model="measure.name"
                                          :disabled=true></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="2">
                            <label>Measure Category:</label>
                        </b-col>
                        <b-col cols="10">
                            <b-form-select id="question-category" v-model="measure.type"
                                           :options="questionRequireOptions" :disabled=true></b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="2">
                            <label :for="`question-type${ measure._id }`">Measure Type:</label>
                        </b-col>
                        <b-col cols="10">
                            <b-form-select :id="`question-type${ measure._id }`" v-model="controlType"
                                           :options="questionTypeOptions" :disabled=false></b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="2">
                            <label :for="`question-text${ measure._id }`">Question Text:</label>
                        </b-col>
                        <b-col cols="10">
                            <b-form-textarea rows="3" max-rows="6" :id="`question-text${ measure._id }`"
                                             v-model="measure.title">
                            </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="2">
                            <label :for="`question-text${ measure._id }`">Green Note:</label>
                        </b-col>
                        <b-col cols="10">
                            <b-form-textarea rows="3" max-rows="6" :id="`question-text${ measure._id }`"
                                             v-model="measure.greenNote">
                            </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="2"><label :for="`question-qnum${measure._id}`">Question Number</label></b-col>
                        <b-col cols="10">
                            <b-form-input :id="`question-qnum${ measure._id }`" v-model="measure.qnum" :disabled=true>{{
                                measure.qnum}}
                            </b-form-input>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="1">
            </b-col>
        </b-row>
        <div slot="modal-footer" class="modal-footer">
            <button type="submit" class="btn btn-success" @click="handleOk">Save</button>
            <button type="button" class="btn btn-default" @click="close">Cancel</button>
        </div>
    </b-modal>
</template>

<script>

    export default {
        name: "QuestionEditorModal",
        props: {
            measure: {},
            show: {
                required: true
            }
        },
        data() {
            return {
                questionRequireOptions: [
                    {value: "CORE", text: "CORE"},
                    {value: "ELECTIVE", text: "ELECTIVE"}
                ],
                questionTypeOptions: [
                    {value: "CHECKBOX", text: "CHECKBOX"},
                    {value: "COMMENT", text: "COMMENT"},
                    {value: "MATRIX", text: "MATRIX"},
                    {value: "TEXT", text: "TEXT"}
                ],
                theChoices: [],
                controlType: this.measure.controlType
            }
        },
        mounted() {
            if (this.measure && this.measure.choices) {
                this.measure.choices.forEach((value, i) => {
                    this.theChoices.push({id: i, value: value});
                });
            }
        },
        watch: {
            show(newVal) {
                console.log("Value In QuestionEditorModal: " + newVal);
                console.log(this.$refs.modal1);
                //this.modal1.show();
            }
        },
        destroyed() {
            //Bus.$emit("question-modal", "hide");
        },
        methods: {
            close() {
                this.$refs.modal1.hide();
                this.$emit("edit-measure", this.measure);
            },
            handleOk: function (val) {
                this.$emit("edit-measure", this.measure);
                this.$refs.modal1.hide()
            }
        }
    }
</script>

<style lang="css" scoped>
    .modal {
        background-color: rgba(0, 0, 0, 0.7);
    }

</style>
